import { UserType } from "./CreateUserWizard/types";
/**
 * ゲストユーザー作成（体験ユーザー）
 *
 * CreateUserWizardのラッパーコンポーネント
 * 子供自身が体験ユーザーとして登録する
 */
import { CreateUserWizard } from "./CreateUserWizard";

interface CreateGuestUserProps {
  open: boolean;
  close: () => void;
}

export const CreateGuestUser = ({ open, close }: CreateGuestUserProps) => {
  return <CreateUserWizard open={open} close={close} userType={UserType.GUEST} />;
};
